const EnergoSwitch = ({schema, defaultChecked, handler, id=""}) => {

    return (
        <div className="form-check form-switch">
            <input id={id} className={`form-check-input ${schema}`} type="checkbox" role="switch" checked={defaultChecked} onChange={() => handler()} />
            <label className="form-check-label" htmlFor={id}></label>
        </div>
    )
}
export default EnergoSwitch;